// Commit 23 LCP tuning: rewrite CloudFront photo URLs to the
// same-origin /cdn/ proxy (next.config rewrites) so <img> requests
// reuse the document's HTTP/2 connection. Schema/OG URLs keep the
// absolute CloudFront form - only rendered <img>/preload tags switch.
const CDN_ORIGIN = "https://d154w98knb4f7r.cloudfront.net/";

export function sameOriginPhotoUrl(url: string): string {
  return url.startsWith(CDN_ORIGIN) ? "/cdn/" + url.slice(CDN_ORIGIN.length) : url;
}
